import { Component, OnInit } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { ResponseDefine } from "../../../../@core/model/response-define";

@Component({
  selector: "ngx-queue-case-defination",
  templateUrl: "./queue-case-defination.component.html",
  styleUrls: ["./queue-case-defination.component.scss"],
})
export class QueueCaseDefinationComponent implements OnInit {
  data: ResponseDefine = new ResponseDefine();
  listFail: any;
  item: any;
  isUpdate: boolean = false;
  updateData = null;
  constructor(private ref: NbDialogRef<QueueCaseDefinationComponent>) {}

  ngOnInit(): void {
    this.listFail = [
      "Other",
      "Join Empty",
      "Leave Empty",
      "Full",
    ];

    if (Array.isArray(this.item)) {
      for (var i = 0; i < this.item.length; i++) {
        if (this.item[i].value) {
          if (this.isUpdate && this.item[i].value == this.updateData) {
            this.data.method = this.updateData;
          } else {
            var index = this.listFail.indexOf(this.item[i].value);
            if (index > -1) {
              this.listFail.splice(index, 1);
            }
          }
        }
      }
    }

    if (this.listFail.length == 1) {
      this.data.method = this.listFail[0];
      this.ref.close(this.data);
    }
  }

  ngOnDestroy(): void {}

  dismiss() {
    this.ref.close(null);
  }
  save() {
    this.ref.close(this.data);
  }
}
